module.exports = __webpack_public_path__ + "static/media/wordchainIsOver.3454a4b3.mp3";